import { AlarmTypeColorMappingsResponse } from '@hakimo-ui/hakimo/types';
import useAuthenticatedRequest from '../shared/useAuthenticatedRequest';

export function useAlarmTypeColorMappings() {
  const url = `/v2/orm/alarm_type/color_mappings`;
  const request = new Request(url);

  return useAuthenticatedRequest<AlarmTypeColorMappingsResponse>(request, {
    queryKey: ['alarm-type-color-mappings'],
    responseModifier: async (response) => {
      const respJson = await response.json();
      return respJson;
    },
  });
}

export default useAlarmTypeColorMappings;
